import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { LocalStorage, LocalStorageService } from 'ngx-store';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {
  @LocalStorage() companyName: string;

  public settings: Settings;
  constructor(public appSettings:AppSettings, private localstorage : LocalStorageService) {
      this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.companyName = this.localstorage.get('companyName');
  }

}
